/**
 * Troncature SÛRE pour un texte contenant du LaTeX $...$ (programme 2025) :
 * couper au milieu d'une formule laisserait un dollar orphelin affiché brut
 * par MathText — si la coupe tombe dans un segment $...$, elle s'étend
 * jusqu'au $ fermant avant d'ajouter les points de suspension.
 *
 * @returns {{ truncated: string, isTruncated: boolean }}
 */
export const tronquerTexteMaths = (text, maxLength = 100) => {
    if (!text || text.length <= maxLength) return { truncated: text, isTruncated: false };
    let coupe = maxLength;
    const avant = text.substring(0, coupe);
    const nbDollars = (avant.match(/\$/g) || []).length;
    if (nbDollars % 2 === 1) {
        const fermant = text.indexOf('$', coupe);
        coupe = fermant === -1 ? text.length : fermant + 1;
    }
    if (coupe >= text.length) return { truncated: text, isTruncated: false };
    return { truncated: text.substring(0, coupe) + '...', isTruncated: true };
};
